import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from "../../../Components/Button/Button";
import imgBottom from "../../../assets/images/home/bottomBg.webp";
import "./FinalCTA.css";

const FinalCTA = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleDownloadClick = () => {
    history.push("/download");
  };

  return (
    <section className="final-cta-wrapper">
      <div className="final-cta-container">
        {/* Top Graphic */}
        <div className="final-cta-visual">
          <img src={imgBottom} alt="IKI AI Characters" className="bottom-characters-img" />
        </div>

        {/* Text Content */}
        <div className="final-cta-content">
          <h2 className="final-cta-title global-title">{t("home.final_cta.title")}</h2>
          <p className="final-cta-subtitle global-subtitle">
            {t("home.final_cta.subtitle")}
          </p>

          <div className="final-cta-button-box">
            <Button
              title={t("home.final_cta.btn")}
              onClick={handleDownloadClick}
              className="final-cta-btn"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
